var React = require('react');

function BoldArrowLeft (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16 7a1 1 0 0 1-1 1H3a1 1 0 1 1 0-2h12a1 1 0 0 1 1 1Z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.64 13.768a1 1 0 0 0 .128-1.408L2.302 7l4.466-5.36A1 1 0 1 0 5.232.36l-5 6a1 1 0 0 0 0 1.28l5 6a1 1 0 0 0 1.408.128Z","key":1})]);
}

BoldArrowLeft.defaultProps = {"viewBox":"0 0 16 14","fill":"current"};

module.exports = BoldArrowLeft;

BoldArrowLeft.default = BoldArrowLeft;
